import { render, staticRenderFns } from "./ScaleView.vue?vue&type=template&id=23908473"
import script from "./ScaleView.ts?vue&type=script&lang=ts&external"
export * from "./ScaleView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports